import { render, staticRenderFns } from "./_PointsParticuliers.vue?vue&type=template&id=35fc4500&scoped=true"
import script from "./_PointsParticuliers.vue?vue&type=script&lang=ts"
export * from "./_PointsParticuliers.vue?vue&type=script&lang=ts"
import style0 from "./_PointsParticuliers.vue?vue&type=style&index=0&id=35fc4500&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc4500",
  null
  
)

export default component.exports